<template>
	<BaseLayout background-color-class="bg-color-white" :content-full-height="true">
		<template #header>
			<HeaderBasic />
		</template>
		<main class="container">
			<div class="col-12 col-10-md col-offset-1-md col-8-lg col-offset-2-lg">
				<p class="overline mb-25">Fundrise for Advisors</p>
				<h1 class="heading-2 line-height-125">Create an advisor account</h1>
				<p class="mt-50 mb-150">
					Following the setup of your account, you can invite your clients and view their investments.
				</p>
				<AdvisorCreationForm />
			</div>
		</main>
	</BaseLayout>
</template>

<script setup lang="ts">
import AdvisorCreationForm from '@components/advisor/advisor-creation-form.vue';
import HeaderBasic from '@components/header/header-basic.vue';
</script>
